import { DraggableLocation } from "@hello-pangea/dnd";
import { Menu, MenuItem } from "@mui/material";
import { HiddenChip } from "components/Layout";
import { useCallback } from "react";
import { IDraggableAlignmentResultSection, ISectionGroup, SectionGroup } from "store/types";
import { styled } from "styled-components";

interface IProps {
  state: any;
  anchor: any;
  onClose: () => any;
  onMove: (section: IDraggableAlignmentResultSection, destination: DraggableLocation) => any;
  onExclude?: (section: IDraggableAlignmentResultSection) => any;
  section: IDraggableAlignmentResultSection;
}

const StyledMenuItem = styled(MenuItem)`
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  color: #252525;
`;

const StyledRedMenuItem = styled(StyledMenuItem)`
  color: #e2221b;
`;

export const SectionMoveMenu = ({ state, anchor, onClose, onMove, onExclude, section }: IProps) => {
  const onClick = useCallback(
    (destinationSection: IDraggableAlignmentResultSection) => {
      const destination = {
        droppableId: destinationSection.uid,
        index: destinationSection.resourceIds.length,
      } as DraggableLocation;
      onMove(section, destination);
      onClose();
    },
    [onClose, onMove, section],
  );

  const onExcludeClick = useCallback(() => {
    onExclude && onExclude(section);
    onClose();
  }, [onClose, onExclude, section]);

  return (
    <Menu
      anchorEl={anchor}
      id="moveall-menu"
      open={Boolean(anchor)}
      onClose={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      {state.sectionGroups
        .filter((sectionGroup: ISectionGroup) => sectionGroup.name === SectionGroup.SORTED)
        .map((sectionGroup: ISectionGroup) => {
          return sectionGroup.sections
            .filter((s: IDraggableAlignmentResultSection) => s.uid !== section.uid)
            .map((s: IDraggableAlignmentResultSection, index, { length }) => {
              return (
                <StyledMenuItem key={index} divider={index == length - 1} onClick={() => onClick(s)}>
                  {s.name}&nbsp;&nbsp;
                  {!s.visible && <HiddenChip label="Hidden" />}
                </StyledMenuItem>
              );
            });
        })}
      {onExclude && (
        <StyledRedMenuItem key={"excluded"} onClick={onExcludeClick}>
          Exclude
        </StyledRedMenuItem>
      )}
    </Menu>
  );
};
